import { logger as garnishLogger } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

garnishLogger.enable('ORDERING_MACHINE');

const log = garnishLogger.extend('ORDERING_MACHINE');

export { log as orderingMachineLog };
